import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        meta: {
            title: 'VidGen: Unleash the Power of AI Video Generation',
        },
        component: Home
    },
    {
        path: '/about',
        name: 'About',
        meta: {
            title: 'About Us',
        },
        component: () =>
            import ('../views/About.vue')
    },
    {
        path: '/contact-us',
        name: 'Contact',
        meta: {
            title: 'Contact Us',
        },
        component: () =>
            import ('../views/Contact.vue')
    },
    {
        path: '/destroy',
        name: 'Destroy',
        meta: {
            title: 'Destroy Data'
        },
        component: () => import ('../views/Destroy.vue')
    },
    // {
    //     path: '/privacy-policy',
    //     meta: {
    //         title: 'Privacy policy'
    //     },
    //     component: () =>
    //         import ('../views/PrivacyPolicy.vue')
    // },
    // {
    //     path: '/privacy',
    //     name: 'Privacy',
    //     meta: {
    //         title: 'Privacy policy'
    //     },
    //     component: () =>
    //         import ('../views/Privacy.vue')
    // },
    {
        path: '/privacypolicy',
        name: 'Privacy2',
        meta: {
            title: 'Privacy policy'
        },
        component: () =>
            import ('../views/Privacy2.vue')
    },
    {
        path: '/terms',
        name: 'Terms',
        meta: {
            title: 'Terms of Service'
        },
        component: () =>
            import ('../views/Terms.vue')
    },
    {
        path: '/guidelines',
        name: 'Conduct',
        meta: {
            title: 'Community Guidelines',
        },
        component: () => import ('../views/Conduct.vue')
    },
    // {
    //     path: '/privacy-zh',
    //     name: 'Privacy',
    //     meta: {
    //         title: 'Privacy policy'
    //     },
    //     component: () =>
    //         import ('../views/PrivacyEN.vue')
    // },
    // {
    //     path: '/terms-en',
    //     meta: {
    //         title: 'Terms of Service'
    //     },
    //     component: () =>
    //         import ('../views/TermsEN.vue')
    // },
    // {
    //     path: '/privacy-zh',
    //     meta: {
    //         title: '隐私政策'
    //     },
    //     component: () =>
    //         import ('../views/PrivacyZH.vue')
    // },
    // {
    //     path: '/terms-zh',
    //     meta: {
    //         title: '用户协议'
    //     },
    //     component: () =>
    //         import ('../views/TermsZH.vue')
    // },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (window.$lang == 'zh' && to.meta.titleZH) {
        document.title = to.meta.titleZH
    } else {
        document.title = to.meta.title
    }
    next()
})

export default router